import React, {Component} from 'react';

class Category extends Component {
    state = {  }
    render() { 
        return ( <div>Hello</div> );
    }
}
 
export default Category;